import React, { useState } from "react";

const FilterButtons = () => {
  const [keyword, setKeyword] = useState("");
  const industries = [
    "All industries",
    "Federal and state government",
    "Manufacturing",
    "Education",
    "Defence",
    "Utilities",
    "Local government",
    "Financial services",
    "Automotive retail",
    "Infrastructure",
    "Retail",
  ];
  const services = [
    "All services",
    "Advisory and consulting",
    "Cloud services",
    "Business applications",
    "Data and integration",
    "Managed services",
  ];
  const partners = [
    "All partners",
    "Microsoft",
    "Boomi",
    "Software AG",
    "Open Text",
    "QAD",
    "Smartsheet",
    "Nuix",
    "Hewlett Packard",
    "HPE Aruba Networking",
    "HP",
    "Saphos",
    "Veeam",
    "VMware",
    "Vaultspeed",
    "HPE Enterprise",
    "Leapwork",
  ];

  const handleKeywordChange = (e) => {
    setKeyword(e.target.value);
  };

  return (
    <div className="bg-[#4f1951] dark:bg-dark dark:text-dark dark:border-[1px] dark:border-white rounded-2xl  w-[95%] lg:w-[85%] mx-auto px-[20px] lg:px-[50px] py-[50px]">
      <div className=" mx-auto grid gap-1  grid-cols-1 md:grid-cols-5  ">
        <input
          type="text"
          value={keyword}
          onChange={handleKeywordChange}
          placeholder="Enter keyword"
          className=" outline-none duration-300 hover:scale-105  border-r-black p-3 border-b-[1px] rounded-xl "
        />

        <select className=" outline-none border-r-black  p-3 border-b-[1px] rounded-xl ">
          {industries.map((industry) => (
            <option key={industry} value={industry}>
              {industry}
            </option>
          ))}
        </select>

        <select className=" outline-none p-3 border-r-black border-b-[1px] rounded-xl ">
          {services.map((service) => (
            <option key={service} value={service}>
              {service}
            </option>
          ))}
        </select>

        <select className=" outline-none p-3 border-r-black border-b-[1px] rounded-xl ">
          {partners.map((partner) => (
            <option key={partner} value={partner}>
              {partner}
            </option>
          ))}
        </select>

        <button className="bg-white dark:bg-dark dark:text-light dark:border-[1px] dark:border-white  dark:hover:text-dark dark:hover:bg-light  hover:bg-black  hover:text-white text-[#4f1951] font-bold py-2 px-4 rounded-lg duration-300 hover:scale-90">
          Search
        </button>
      </div>
    </div>
  );
};

export default FilterButtons;
